import React from 'react';
import {Link} from "gatsby";
// import IllustrationBanner from "../../static/img/Home/IllustrationBanner.svg"
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';

const AutoPlaySlider = withAutoplay(AwesomeSlider)
const Carousels = ({banner}) => {

  return (
    <>

    <AutoPlaySlider className='carousel'play={true}
    animation="cube-animation"
    infinite={true}
    cancelOnInteraction={false}
    interval={5000}
    >
    {  
  banner?.map((item, index)=>{
    return (

    <div data-src={item.bannerPath} >
         <div className="right-container">

              <div className="content-container">

              {index === 0 ? <h1>{item.heading}</h1> : <h2>{item.heading}</h2>}

              {item.bannerContent?.map((data)=>(<p>{data}</p>))}
            <div className="carousel-cta-group">
              <Link align="center" to={'/demo/'}><button align="center" className="carousel-cta-btn carousel-cta-btn--primary">Book Demo</button></Link>
              <Link align="center" to={'/contactus/'}><button align="center" className="carousel-cta-btn">Contact Us</button></Link>
            </div>
              </div>
            

        
        {/* <div className="illustartion"> */}
          {/* <img src={IllustrationBanner} alt="" /> */}
        {/* </div> */}
        </div>
    </div>
    )
  })
 }
    </AutoPlaySlider>
</>
)
}

export default Carousels